import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { EmailData } from '~shared/models/general/email-data.model';

@Injectable({
  providedIn: 'root',
})
export class MailService {
  private mailWindowVisibleSubject = new BehaviorSubject<boolean>(false);
  mailWindowVisible$ = this.mailWindowVisibleSubject.asObservable();

  private emailsSubject = new BehaviorSubject<EmailData[]>([]);
  emailsData$ = this.emailsSubject.asObservable();
  private nextId = 1;

  addEmailWindow(emailData: Partial<EmailData>) {
    const email: EmailData = {
      id: this.nextId++,
      reduced: false,
      ...emailData,
    } as EmailData;
    this.closeAllEmailWindowsExcept(email.id);
    this.emailsSubject.next([...this.emailsSubject.value, email]);
  }

  removeEmailWindow(id: number) {
    this.emailsSubject.next(
      this.emailsSubject.value.filter((email) => email.id !== id)
    );
  }

  closeAllEmailWindowsExcept(id: number) {
    this.emailsSubject.next(
      this.emailsSubject.value.map((email) => {
        email.reduced = false;
        if (email.id !== id) {
          email.reduced = true;
        }
        return email;
      })
    );
  }
}
